module.exports = __webpack_public_path__ + "email2.png?ff7b2f135a333dcd754863b92ec60cdb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email2.png
// module id = 26
// module chunks = 0